import { Box, BoxProps, ColorOptions, IconNew, Spacer } from '@jfs/ui-new'
import { TextInput } from '../AdminInputs'
import { isEmpty } from '@jfs/utils'
import { FC, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'

interface SearchFilterProps {
  isFilter?: boolean
  filterData?: any
  onSearch: (data: { search: string; filter?: string }) => void
  placeholder?: string
  onChange?: (val: string) => void
  textWidth?: number
}

const SearchFilter: FC<SearchFilterProps> = (props: SearchFilterProps) => {
  const { isFilter = false, onSearch, filterData = [], placeholder = 'Search By', onChange, textWidth } = props
  const [focus, setFocus] = useState(false)
  const [searchFilter, setSearchFilter] = useState({ search: '', filter: '' })
  const onFilter = (value: any) => {
    console.log({ value })
    setSearchFilter({
      ...searchFilter,
      search: value === 'Is Active' ? 'true' : searchFilter?.search,
      filter: value,
    })
  }

  const handleSearch = () => {
    onSearch(searchFilter)
  }

  const handleChange = (value: string) => {
    onChange && onChange(value)
    setSearchFilter({
      ...searchFilter,
      search: value,
    })
  }

  const getSearchBoxStyles = () => {
    return isFilter ? styles.searchBoxFull : styles.searchBox
  }

  const getbuttonStyles = () => {
    return isFilter ? styles.filterButton : styles.searchButton
  }

  return (
    <Box flexDirection="row" alignItems="center" flexWrap="wrap">
      {searchFilter?.filter !== 'Is Active' && (
        <Box {...getSearchBoxStyles()} borderColor={'#d1d3e2' as ColorOptions} borderWidth={1}>
          <TextInput
            showBottomLine={false}
            placeholder={placeholder}
            onChange={handleChange}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            fontFamily={'jiotype-medium'}
            fontSize={12}
            textWidth={textWidth}
          />
        </Box>
      )}
      {isFilter && (
        <Box flexDirection="row" paddingVertical={8}>
          <Spacer direction="horizontal" size={4} />
          <Dropdown data={filterData} title="Filter" selectedData={onFilter} minWidth={200} />
          <Spacer direction="horizontal" size={4} />
        </Box>
      )}
      <Box {...getbuttonStyles()} onPress={handleSearch} disabled={isEmpty(searchFilter?.search)}>
        <IconNew id="SEARCH" size={16} color="WHITE" weight={'dense'} />
      </Box>
    </Box>
  )
}

export { SearchFilter }

const styles = {
  searchButton: {
    backgroundColor: '#214796' as ColorOptions,
    w: 40,
    h: 40,
    align: 'center',
    justify: 'center',
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  filterButton: {
    backgroundColor: '#214796' as ColorOptions,
    w: 40,
    h: 38,
    align: 'center',
    justify: 'center',
    borderRadius: 4,
    underlayColor: 'TRANSPARENT',
  } as BoxProps,

  searchBox: {
    backgroundColor: 'WHITE',
    border: 2,
    borderColor: 'GREY_SEPARATOR',
    paddingHorizontal: 8,
    paddingVertical: 10,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,

    borderWidth: 2,
    borderRightWidth: 0,
    borderTopRightRadius: 0,
  } as BoxProps,

  searchBoxFull: {
    backgroundColor: 'WHITE',
    borderColor: 'GREY_SEPARATOR',
    padding: 8,
    borderRadius: 4,
    borderWidth: 1,
  } as BoxProps,
}
